import React from "react";
import AddIcon from "@mui/icons-material/Add";
import useAuth from "src/hooks/useAuth";
import { allowedToCreateEntity } from "src/constants/role";
import { Link } from "react-router-dom";
import { path } from "src/constants/path";
import Controls from "src/components/form/controls/Controls";

const EmployeeControlPanel = ({ permissionsAccessControl, children }) => {
  const { auth } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.systemEmployee}/add`,
            }}
          >
            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<AddIcon />}
            />
          </Link>
        )}
      </div>
    </div>
  );
};

export default EmployeeControlPanel;
